export default __webpack_public_path__ + "static/media/fpb60004.394f9bb2.png";